import {
  Configuration,
  GenesisAirdropControllerApi,
  LeaderboardControllerApi,
  OraclePriceControllerApi,
  PairInfoControllerApi,
  PortfolioControllerApi,
  SLVMONAPIApi,
  TradeHistoryControllerApi,
  TradingCompetitionApi,
} from '../generated';
import {
  Configuration as OneClickConfiguration,
  TradingControllerApi,
  TradingV2ControllerApi,
} from '../oneClickServiceGenerated';

const configuration = new Configuration({
  basePath: process.env.NEXT_PUBLIC_BACKEND_BASE_URL,
});
const oneClickServiceConfiguration = new OneClickConfiguration({
  basePath: process.env.NEXT_PUBLIC_ONECLICK_SERVICE_BASE_URL,
});
export const pairInfoControllerApi = new PairInfoControllerApi(configuration);
export const portfolioControllerApi = new PortfolioControllerApi(configuration);
export const genesisAirdropControllerApi = new GenesisAirdropControllerApi(
  configuration,
);
export const leaderboardControllerApi = new LeaderboardControllerApi(configuration);
export const slvmonApi = new SLVMONAPIApi(configuration);
export const tradeHistoryControllerApi = new TradeHistoryControllerApi(
  configuration,
);
export const oraclePriceControllerApi = new OraclePriceControllerApi(configuration);
export const oneClickTradingControllerApi = new TradingControllerApi(oneClickServiceConfiguration);
export const tradingV2ControllerApi = new TradingV2ControllerApi(oneClickServiceConfiguration);

export const tradingCompetitionApi = new TradingCompetitionApi(configuration);